import {agentStatuses} from "./constants";
import NoSleep from "nosleep.js";

export var CallDetails = {
CLI:'',
DDI:'',
StartTime:'',
EndTime:'',
};
export var SecondaryOutcomes = {
    Id:'',
    Code:'',
    Title:'',
};

export var PrimaryOutcomes = {
    Id:'',
    Code:'',
    Title:'',
    SecondaryOutComes:[SecondaryOutcomes]
};

export var SettingsACD = {
    AbsenseReasons:[],
    PrimaryOutcomeTitle:'',
    SecondaryOutcomeTitle:'',
    PrimaryOutcomeEnable:'',
    SecondaryOutcomeEnable:'',
    PrimaryOutComes:[PrimaryOutcomes],
};
//const newACDSettings = new ACDSettings();

export var AgentGroupInfo = {
    Name:'',
    SkillLevel:'',
    IsAvailable:'',
    QueueAbr:'',
    Color:'',
    GroupNumber:'',
    AgentId:'',
    QueueId:''
};

export var AgentState = {
    LoggedinTime: 0,
    IsLoggedin:'false',
    RaiseHandTime:0,
    RaiseHand:false,
    AvailabilityTime:0,
    IsAvailable:true,
    UnAvailabilityReason:'',
    RemoteId:'',
    AgentState: agentStatuses.Temp_Absent,
    AgentExtension:'',
    AutoAnswer:false,
    LogoutRinging:'false',
    Direction:'',
    OtherParty:'',
    CallType:'I',
    LastGroupName:'',
    LastGroupNumber:'',
    CallerNumber:'',
    CSTACallID:'',
    PhoneExtension:'',
    AcdBusyStartTime:'',
    LastStateTime:'',
    Name:'',
    Gender:'',
    Email:'',
    ImagePath:'',
    Error:'',
    AssociatedGroups:[AgentGroupInfo],
    WrapUp_Remaining:''
};

export var LoginResponse = {
    AccountID:0,
    AgentExtension:'',
    PhoneExtension:'',   
    IsSuccess:false,
    Error:'',
    RemoteID: '',
    CheckEnterpriseLicense:false,
    IsAgentWallboardLicensed:false,
    SettingsACD:SettingsACD,
    AgentStatus:AgentState,

};

export var GroupCallRinging = {
    AgentExtension: '',
    PhoneExtension: '',
    GroupNumber: '',
    SipProfileNumber: '',
    LastDivertTo: null,
    GroupName:'',
    CallerNumber:'',
    CallTime:'',
    RemoteID:'',
    CallID:0,
    AgentCallID:0,
    CSTACallID:'',
};

export var ListStats = {
    StatId: '',
    StatValue: '',
};
export var VBoardStatsChanged = {
    GroupId: '',
    GroupName: '',
    GroupNumber: '',
    ListStats: [ListStats],
};
export var VBoardStats = {
    VBoardsStatsChanged:[],
};

export var ringToneObj = new Audio();
export var noSleep = new NoSleep();